@if (isLoading) {
  <app-main-loader-lottie> </app-main-loader-lottie>
} @else {
  <form class="settings-fields-container" [formGroup]="formGroup" (submit)="onSubmit()">
    <div class="fields-area" [ngClass]="fieldsAreaClasses">
      <div class="settings-header-row">
        <span class="title">Order Verification Settings</span>
        <hr />
        <span class="description">Choose which details to check on new orders in Verify screen</span>
      </div>
      @for (field of fieldsList; track field) {
        <div class="container" [ngClass]="{ disabled: field.disabledWhen && field.disabledWhen(shop) }">
          <div class="settings-row-container">
            <div class="description-col">
              <div class="sub-title">{{ field.title }}</div>
              <div class="description">{{ field.description }}</div>
            </div>
            <div class="row-end">
              <div class="preview-col">
                <span class="warn-preview">{{ field.warnText }}</span>
              </div>
              <div class="button-col">
                @if (field.dataName) {
                  <pdq-slide-toggle
                    (onToggle)="field.dataName === 'isActiveWeather' ? weatherToggled($event) : undefined"
                    [id]="field.dataName"
                    [formControlName]="field.dataName"></pdq-slide-toggle>
                }
              </div>
            </div>
          </div>
          <!-- additional specific fields-->
          @if (field.dataName === 'isActiveWeather') {
            <div class="additional-settings-container" [hidden]="!isDisplayedWeather">
              <ng-container *ngTemplateOutlet="weather; context: { data: field.additionalInfo.data }"></ng-container>
            </div>
          }
          @if (field.additionalInfo?.type === FieldType.CHECKBOX) {
            <div class="additional-settings-container">
              <ng-container *ngTemplateOutlet="address; context: { data: field.additionalInfo.data }"></ng-container>
            </div>
          }
          @if (field.additionalInfo?.type === FieldType.TOGGLE) {
            <div class="additional-settings-container inventory-container">
              <ng-container *ngTemplateOutlet="toggle; context: { data: field.additionalInfo.data }"></ng-container>
            </div>
          }
        </div>
      }
    </div>
    <footer [ngClass]="footerState">
      <span>{{ changedStatusTxt }}</span>
      <pdq-button variant="secondary" (click)="resetForm()" label="cancel" class="action-btn">cancel</pdq-button>
      <pdq-button
        variant="primary"
        type="submit"
        label="save"
        class="action-btn"
        [disabled]="!isEnabledSave"
        (click)="onSubmit()"
        >save</pdq-button
      >
    </footer>
    <div class="notification-area">
      <pdq-snackbar
        [variant]="notification.type"
        [notificationText]="notification.msg"
        [notificationDuration]="notification.duration"
        [notificationState]="notification.state">
      </pdq-snackbar>
    </div>
    <!-- templates -->
    <ng-template #address let-data="data">
      @for (field of data; track field) {
        <span class="additional-checkbox">
          <pdq-checkbox
            variant="hyper"
            [formControlName]="field.dataName"
            labelVariant="secondary"
            labelSize="small"
            [label]="field.description"
            [stringValue]="field.stringValue"
            [disabled]="isDisabledFeature(field.dataName)"
            [checked]="field.value">
          </pdq-checkbox>
          @if (field.tooltip) {
            <pdq-icon
              class="icon"
              icon="more_information"
              [matTooltip]="field.tooltip"
              matTooltipClass="pdq-mat-tooltip">
            </pdq-icon>
          }
        </span>
      }
    </ng-template>
    <ng-template #weather let-data="data">
      <div class="temp-row">
        <div class="temp-col">
          <span>
            <label>{{ data[0].description }}</label>
            <pdq-slide-toggle
              [formControlName]="data[0].dataName"
              (onToggle)="tempToggled($event, data[1].dataName)"></pdq-slide-toggle>
          </span>
          <pdq-input-units
            [formControlName]="data[1].dataName"
            size="small"
            (ngModelChange)="onTempChanged(data[1].dataName, $event)"
            (onBlur)="onTempBlur(data[1].dataName, $event)"
            [invalid]="isInvalidField(data[1].dataName)"></pdq-input-units>
        </div>
        <div class="temp-col">
          <span>
            <label>{{ data[2].description }}</label>
            <pdq-slide-toggle
              #maxTempToggle
              [formControlName]="data[2].dataName"
              (onToggle)="tempToggled($event, data[3].dataName)"></pdq-slide-toggle>
          </span>
          <pdq-input-units
            size="small"
            [formControlName]="data[3].dataName"
            (ngModelChange)="onTempChanged(data[3].dataName, $event)"
            (onBlur)="onTempBlur(data[3].dataName, $event)"
            [invalid]="isInvalidField(data[3].dataName)"></pdq-input-units>
        </div>
      </div>
      @if (isInvalidField(data[3].dataName) || isInvalidField(data[1].dataName)) {
        <span class="invalid-msg">*{{ getInvalidTemperatureTxt(data[1], data[3]) }}</span>
      }
      <pdq-input
        [formControlName]="data[4].dataName"
        [invalid]="isInvalidField(data[4].dataName)"
        [invalidMsg]="data[4].validationMsg"
        class="weather-input"
        label="processing days"
        variant="form"
        size="small"
        type="number"></pdq-input>
    </ng-template>
    <ng-template #toggle let-data="data">
      @for (field of data; track field) {
        <span class="additional-toggle">
          <span class="description blue">{{ field.description }}</span>
          <pdq-slide-toggle
            class="inventory-toggle"
            [id]="field.dataName"
            [formControlName]="field.dataName"></pdq-slide-toggle>
        </span>
      }
    </ng-template>
  </form>
}
